import React from 'react';

export const IconPlayBlackSmall = () => {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.7205 1.42676C1.25108 1.15976 0.666992 1.49713 0.666992 2.03529V8.96483C0.666992 9.50298 1.25108 9.84034 1.7205 9.5733L7.81218 6.10853C8.28526 5.83951 8.28526 5.1606 7.81218 4.89158L1.7205 1.42676Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.7205 1.42676C1.25108 1.15976 0.666992 1.49713 0.666992 2.03529V8.96483C0.666992 9.50298 1.25108 9.84034 1.7205 9.5733L7.81218 6.10853C8.28526 5.83951 8.28526 5.1606 7.81218 4.89158L1.7205 1.42676Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
